import { GOOGLE_TAG_MANAGER_ID } from 'utils/consts';
import { noop } from 'utils/noop';

import { EventTraits, LocationDetails, LocationTraits, UserTraits } from './types';

const isEnabled = !!GOOGLE_TAG_MANAGER_ID;

export interface WindowProperties {
  dataLayer: Record<string, unknown>[];
}

export const initialize = isEnabled
  ? () => {
      window.dataLayer = window.dataLayer ?? [];
      window.dataLayer.push({
        'gtm.start': +new Date(),
        event: 'gtm.js',
      });
    }
  : noop;

export const load = isEnabled
  ? () => {
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${GOOGLE_TAG_MANAGER_ID}`;

      document.getElementsByTagName('head')[0].appendChild(script);
    }
  : noop;

export const trackPage = isEnabled
  ? (_locationTraits: LocationTraits, locationDetails: LocationDetails) => {
      window.dataLayer?.push({
        event: 'page_view',
        page_location: locationDetails.location,
        page_path: locationDetails.path,
        page_title: locationDetails.title,
      });
    }
  : noop;

export const trackEvent = isEnabled
  ? ({ name }: EventTraits) => {
      window.dataLayer?.push({
        event: name,
        event_category: 'auth',
      });
    }
  : noop;

export const identifyUser = isEnabled
  ? ({ id }: UserTraits) => {
      window.dataLayer?.push({ userId: id });
    }
  : noop;

export const resetUser = isEnabled
  ? () => {
      window.dataLayer?.push({ userId: undefined });
    }
  : noop;
